import { getAverageRegistrationTimeMs } from '../measurements/trackFileRegistrationTime';
import { convertBytesPerSecondToMbps } from '../../../../libs/convertBytesPerSecondToMbps';
import { Point } from '@influxdata/influxdb-client-browser';
import { influxWriter } from '../../../../libs/metrics/InfluxWriter';

export const sendUploadSpeedMetric = (bytesPerSecond: number) => {
  const fileUploadSpeedMbps = convertBytesPerSecondToMbps(bytesPerSecond);

  const fileRegistrationTimeMs = getAverageRegistrationTimeMs();
  if (fileRegistrationTimeMs === InitialFileRegistrationTimeMs) return;

  const point = new Point();

  point.floatField('fileUploadSpeedMbps', fileUploadSpeedMbps);
  point.floatField('fileRegistrationTimeMs', fileRegistrationTimeMs);

  influxWriter.send('AverageSpeedStats', point);
};
